import React, { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router';

import pages from 'pages';
import { Billing } from 'modules/billing/screens/Billing';
import { AgreementDetails } from 'modules/overview/screens/AgreementDetails/AgreementDetails';
import { HardwareInfo } from 'modules/system/screens/HardwareInfo/HardwareInfo';
import { ErrorFallback } from 'shared/components/ErrorBoundary/ErrorFallback';
import { DashboardLayout } from 'layouts/DashboardLayout';
import { LoadingLogo } from 'shared/components/Modal/LoadingLogo';
import { VppDetails } from 'modules/overview/screens/VppDetails/VppDetails';
import { VPP } from 'modules/vpp/screens/VPP/VPP';
import { VPPFAQs } from 'modules/vpp/screens/VPPFAQs/VPPFAQs';
import { VPPFAQ } from 'modules/vpp/screens/VPPFAQ/VPPFAQ';
import { Support } from './support';

const Overview = lazy(() => import('modules/overview/screens/Overview'));
const SystemPage = lazy(() => import('modules/system/screens/SystemPage/SystemPage'));

export const Dashboard: RouteObject[] = [
  {
    element: <DashboardLayout />,
    children: [
      {
        path: `${pages.DASHBOARD}/*`,
        children: [
          {
            index: true,
            element: <Navigate to={`/${pages.DASHBOARD}/${pages.OVERVIEW}`} replace />,
          },
          {
            path: pages.OVERVIEW,
            element: (
              <Suspense fallback={<LoadingLogo />}>
                <Overview />
              </Suspense>
            ),
          },
          { path: `${pages.AGREEMENTS}/:agreementId`, element: <AgreementDetails /> },
          {
            path: pages.SYSTEM,
            children: [
              {
                index: true,
                element: (
                  <Suspense fallback={<LoadingLogo />}>
                    <SystemPage />
                  </Suspense>
                ),
              },
              { path: pages.HARDWARE_INFO, element: <HardwareInfo /> },
              { path: pages.VPP_DETAILS, element: <VppDetails /> },
            ],
          },
          ...Support,
          { path: pages.BILLING, element: <Billing /> },
          {
            path: pages.VPP,
            children: [
              { index: true, element: <VPP /> },
              { path: pages.VPP_FAQS, element: <VPPFAQs /> },
              { path: pages.VPP_FAQ, element: <VPPFAQ /> },
            ],
          },
        ],
        errorElement: <ErrorFallback is404 />,
      },
    ],
  },
];

export default Dashboard;
